import {SvgIcon, useTheme} from '@mui/material';

export default function CityIcon() {
	const theme = useTheme();
	return (
		<SvgIcon width="16" height="16" viewBox="0 0 16 16" fill="none">
			<path opacity="0.4"
			      d="M5.70686 2.22668V11.78C5.48019 11.7867 5.25352 11.84 5.08686 11.94L3.52019 12.8334C2.42686 13.46 1.52686 12.94 1.52686 11.6734V5.18668C1.52686 4.76668 1.82686 4.24668 2.20019 4.03335L5.08686 2.38002C5.25352 2.28668 5.48019 2.23335 5.70686 2.22668Z"
			      fill={theme.palette.grey[600]}/>
			<path
				d="M10.4865 4.22V13.7733C10.2532 13.78 10.0265 13.74 9.84654 13.6533L6.34654 11.9C6.16654 11.8133 5.93988 11.7733 5.70654 11.78V2.22667C5.93988 2.22 6.16654 2.26 6.34654 2.34667L9.84654 4.1C10.0265 4.18667 10.2532 4.22667 10.4865 4.22Z"
				fill={theme.palette.grey[600]}/>
			<path opacity="0.4"
			      d="M14.6668 4.32667V10.8133C14.6668 11.2333 14.3668 11.7533 13.9935 11.9667L11.1068 13.62C10.9401 13.7133 10.7135 13.7667 10.4868 13.7733V4.22C10.7135 4.21334 10.9401 4.16 11.1068 4.06L12.6735 3.16667C13.7668 2.54 14.6668 3.06 14.6668 4.32667Z"
			      fill={theme.palette.grey[600]}/>
		</SvgIcon>
	);
}
